export const Svg_132 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M8.75 64.167v-4.375h7.292v-2.187h-4.375V53.23h4.375v-2.188H8.75v-4.375h8.75c.826 0 1.52.28 2.078.839.56.559.839 1.251.839 2.078V52.5c0 .827-.28 1.52-.839 2.078-.559.56-1.252.84-2.078.84.826 0 1.52.279 2.078.838.56.559.839 1.251.839 2.078v2.916c0 .827-.28 1.52-.839 2.078-.559.56-1.252.84-2.078.84H8.75Zm0-20.417v-8.02c0-.827.28-1.52.839-2.078.559-.56 1.251-.84 2.078-.84h4.375v-2.187H8.75V26.25h8.75c.826 0 1.52.28 2.078.839.56.559.839 1.252.839 2.078v5.104c0 .827-.28 1.52-.839 2.078-.559.56-1.252.839-2.078.839h-4.375v2.187h7.292v4.375H8.75Zm4.375-20.416V10.209H8.75V5.834h8.75v17.5h-4.375ZM26.906 54.76v-4.375H61.25v4.375H26.906Zm0-17.719v-4.375H61.25v4.375H26.906Zm0-17.719v-4.375H61.25v4.375H26.906Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.891}
        x2={49.804}
        y1={14.584}
        y2={56.698}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)